/**
 * AiExtractionService
 * Reads structured data off a photographed or scanned document.
 * Route: api/ai/extraction
 * Controller: AIExtractionController.cs
 *
 * Domain-agnostic by design: pass the document type and the fields you are hoping
 * for, get labelled values with per-field confidence back, and map them onto your own
 * entity. Nothing about this service is specific to any one domain.
 */
import { BaseService } from '../base/BaseService';
export class AiExtractionService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiExtractionService.DEFAULT_SERVICE_PATH,
            basePath: AiExtractionService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Extract labelled fields from an image of a document.
     * POST /api/ai/extraction/from-image
     *
     * An unreadable image is NOT an error: the response comes back with a `warning`
     * and no fields, so prompt for a better photo rather than catching an exception.
     */
    async fromImage(request) {
        const response = await this.fromImageRaw(request);
        return (response.data ?? {
            fields: [],
            confidence: 0,
            tokensUsed: 0,
            durationMs: 0,
            warning: response.message ?? 'Extraction failed.',
        });
    }
    fromImageRaw(request) {
        return this.http.post(this.buildUrl('from-image'), request);
    }
}
AiExtractionService.DEFAULT_SERVICE_PATH = 'ai-management';
AiExtractionService.BASE_PATH = 'api/ai/extraction';
//# sourceMappingURL=AiExtractionService.js.map